"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.journeyIdFrom = exports.JourneyTypeMap = exports.JourneyType = void 0;
var JourneyType;
(function (JourneyType) {
    JourneyType["ANNUAL_HOME"] = "ANNUAL_HOME";
    JourneyType["ANNUAL_MOTOR"] = "ANNUAL_MOTOR";
})(JourneyType || (exports.JourneyType = JourneyType = {}));
exports.JourneyTypeMap = new Map([
    [JourneyType.ANNUAL_HOME, [
            "Annual_Home_NB_Journey",
            "Annual_Home_MTA_Journey",
            "Annual_Home_Journey_Policy_Cancellation",
            "Annual_Home_Change_Address",
            "Annual_Home_Forced_Policy_Cancellation",
            "Annual_Home_Journey_Edit_Renewal_Proposal",
            "Falcon_Support_Portal_Cancel_Annual_Home",
            "Falcon_Support_Portal_Cancel_Subscription_Renters",
            "Falcon_Support_Portal_Edit_Customer_Address",
            "Falcon_Support_Portal_Home_MTA",
            "Home_Support_Portal_Change_Address",
            "Home_Support_Portal_Forced_Cancellation"
        ]],
    [JourneyType.ANNUAL_MOTOR, [
            "Wolf_Motor_Journey",
            "Wolf_Motor_Journey_Edit_Car_Details",
            "Wolf_Motor_Journey_Replace_Car",
            "Wolf_Motor_Journey_Policy_Cancelation",
            "Wolf_Motor_Journey_Add_Additional_Driver",
            "Wolf_Motor_Journey_Change_Address",
            "Wolf_Motor_Journey_Edit_Driver_Details",
            "Wolf_Motor_Journey_Remove_Driver",
            "Wolf_Motor_Journey_Payment_Day",
            "Wolf_Motor_Journey_Forced_Policy_Cancelation",
            "Wolf_Motor_Journey_Pay_Off_Balance",
            "Wolf_Motor_Journey_Edit_Registration_Number",
            "Wolf_Motor_Journey_Edit_Renewal_Proposal",
            "Wolf_Motor_Journey_Post_Renewal_Claim_Impact",
            "Wolf_Motor_Journey_Edit_Policy_Start_Date",
            "Wolf_Motor_Edit_Car_Journey",
            "Falcon_Support_Portal_Cancel_Annual_Motor",
            "Falcon_Support_Portal_Cancel_Subscription_Motor",
            "Falcon_Support_Portal_Edit_MTA_Limits",
            "Falcon_Support_Portal_Edit_Named_Driver_Annual_Motor",
            "Falcon_Support_Portal_Annual_Edit_Optional_Extras",
            "Falcon_Support_Portal_Annual_Replace_Car",
            "Falcon_Support_Portal_Add_Additional_Driver"
        ]]
]);
function journeyIdFrom(type, journeyId) {
    var journeyTypes = exports.JourneyTypeMap.get(type);
    return journeyTypes ? journeyTypes.includes(journeyId) : false;
}
exports.journeyIdFrom = journeyIdFrom;
//# sourceMappingURL=JourneyType.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/JourneyType.js
// module id = 2546
// module chunks = 0